import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, Timestamp } from "rxjs";

// ################################################
// INTERFACES
export interface UserLogin {
  password: string;
  logged: boolean;
  restricted: boolean;
  onlyorders: boolean;
}
export interface Result {
  error: boolean;
  data: any;
  message: string;
  value: number;
}
export interface Dipendente {
  id: string;
  code: string;
  name: string;
  surname: string;
  company: string;
  email: string;
  rfid: string;
}
export interface Ordine {
  id: string;
  code: string;
  title: string;
  forecast: number;
  company: string;
  status: boolean;
  total: number;
  date: Date;
  h: number;
  prize: boolean;
  costH: number;
  costM: number;
  costMReal: number;
}
export interface Tempo {
  id: Date;
  date: Date;
  userId: string;
  orderId: string;
  h: number;
}

export interface TimeTable {
  time: number;
  totH: number;
  enters: number[];
}

export interface UserData {
  id: string;
  code: string;
  name: string;
  surname: string;
  company: string;
  ordini: any;
  totH: number;
  times: TimeTable[];
}
export interface Rfid {
  code: string;
  time_enter: number;
  time_exit: number;
  marked: number;
}
export const Aziende: Array<string> = ["Meneghetti"];

// ##############################################
// CLASS
@Injectable()
export class GlobalComponent {
  public userLogin: UserLogin;
  public userData: UserData = {} as UserData;

  public nodeServer: string = "https://nodecheck.emsoft.it/";
  //public nodeServer: string = "http://127.0.0.1:8080/";

  public homeTitle: string;
  public trackTitle: string = "WebCheck";
  public footerTitle: string =
    "WebCheck v26.02.04 - ©2026 Meneghetti Mobili S.r.l.";

  public menuState: number = 0;

  public normalTime: number = 10000;
  public fastTime: number = 3000;

  constructor(private http: HttpClient) {}

  // ################################################
  // ASK TOKEN
  public login(): Observable<Result> {
    return this.http.post<Result>(this.nodeServer + "login", this.userLogin);
  }
  // ################################################
  // ASK ID
  public loginUtente(code: string, rfid: string): Observable<Result> {
    console.log("LOGIN UTENTE");
    return this.http.post<Result>(this.nodeServer + "loginUtente", {
      code: code,
      rfid: rfid,
    });
  }
  // ################################################
  // SEND PREMI
  public sendPremi(
    destinatari: string,
    premi: any[],
    dal: string,
    al: string,
    totale: Number
  ): Observable<Result> {
    return this.http.post<Result>(this.nodeServer + "sendPremi", {
      destinatari: destinatari,
      premi: premi,
      dal: dal,
      al: al,
      totale: totale,
    });
  }
  // ################################################
  // CHECK LOGIN
  public checkLogin(): boolean {
    if (typeof this.userLogin === "undefined") {
      this.getLogin();
    }
    if (this.userLogin.logged === true) {
      return true;
    } else {
      return false;
    }
  }
  public getLogin() {
    const value = sessionStorage.getItem("webcheck");
    if (value) {
      this.userLogin = JSON.parse(value);
    } else {
      this.userLogin = { logged: false } as UserLogin;
    }
  }
  // ################################################
  // CHECK UTENTE
  public checkUserData(): boolean {
    if (typeof this.userData === "undefined") {
      return false;
    } else {
      return true;
    }
  }
  // ################################################
  // MY SQL
  public mysql(query: string): Observable<Result> {
    const obj = {
      query: query,
    };
    return this.http.post<Result>(this.nodeServer + "mysql", obj);
  }
  // ################################################
  // NUMBER LIMIT
  numberLimit(e: KeyboardEvent, n: number) {
    const t: HTMLInputElement = e.target as HTMLInputElement;
    if (e.key !== "Backspace" && e.key !== "Tab") {
      if (Number.isNaN(Number(e.key)) || t.value.length === n) {
        e.preventDefault();
      } else if (t.value.length > n) {
        t.value = t.value.substring(0, n);
      }
    }
  }
  // ################################################
  // KEY LIMIT
  keyLimit(e: KeyboardEvent, n: number) {
    const t: HTMLInputElement = e.target as HTMLInputElement;
    if (e.key !== "Backspace" && e.key !== "Tab") {
      if (t.value.length === n) {
        e.preventDefault();
      } else if (t.value.length > n) {
        t.value = t.value.substring(0, n);
      }
    }
  }
  // ################################################
  // DIFF TIME
  /*diffTime(timeEnter: number, timeExit: number) {
		const backEnter = timeEnter;
		const backExit = timeExit;
		if (timeExit === 0) {
			return 0;
		}

		// ENTER ROUND < 3 = 0 | < 33 = 30 | >= 33 = +1h
		let dateTime = new Date(timeEnter);
		let m = dateTime.getMinutes();
		if (m < 3) {
			dateTime.setMinutes(0, 0, 0);
		} else if (m < 33) {
			dateTime.setMinutes(30, 0, 0);
		} else {
			dateTime.setMinutes(0, 0, 0);
			dateTime.setHours(dateTime.getHours() + 1);
		}
		timeEnter = dateTime.getTime();

		// EXIT ROUND >= 55 = +1h | >= 25 = 30 | < 25 = 0
		dateTime = new Date(timeExit);
		m = dateTime.getMinutes();
		if (m >= 55) {
			dateTime.setMinutes(0, 0, 0);
			dateTime.setHours(dateTime.getHours() + 1);
		} else if (m >= 25) {
			dateTime.setMinutes(30, 0, 0);
		} else {
			dateTime.setMinutes(0, 0, 0);
		}
		timeExit = dateTime.getTime();

		if (backEnter === 1587621369743) {
			console.log("CHECK IN: " + m, backEnter, timeEnter, new Date(timeEnter));
			console.log("CHECK OUT: " + m, backExit, timeExit, new Date(timeExit));
		}
		return Math.round((Math.abs(timeExit - timeEnter) / 36e5) * 100) / 100;
	}*/
	diffTime(timeEnter: number, timeExit: number) {
		if (!timeExit || timeExit <= 0 || !timeEnter) return 0;

		// differenza pura in ore
		const diffHours = Math.max(0, (timeExit - timeEnter) / 36e5);

		// arrotonda verso il basso a step di mezz'ora (0.5h)
		const floored = Math.floor(diffHours * 2) / 2;

		return Math.round(floored * 100) / 100;
	}

	diffTimeRaw(timeEnter: number, timeExit: number) {
		if (!timeExit || timeExit <= 0 || !timeEnter) return 0;

		return Math.max(0, (timeExit - timeEnter) / 36e5);
	}

	roundToHalfDown(hours: number) {
		if (!hours || hours <= 0) return 0;

		const floored = Math.floor(hours * 2) / 2;
		return Math.round(floored * 100) / 100;
	}
}
